import React from 'react';
import DataResource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'

const AccessRights = (props) => {
    const data = {
        url: `/admin/access/rights`,
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: `/admin/access/rights/{id}`,
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Access Group',
                source: 'access_group_id',
                type: 'select'
            },
            {
                label: 'Access Area',
                source: 'access_area_id',
                type: 'select'
            },
            {
                label: 'Can Read',
                source: 'can_read',
                type: 'boolean',
                editable: true,
                visible: true
            },
            {
                label: 'Can Write',
                source: 'can_write',
                type: 'boolean',
                editable: true,
                visible: true
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                visible: true
            },
            {
                label: 'Updated',
                source: 'updated_at',
                type: 'datetime',
                editable: false,
                visible: true
            },
            {
                label: 'Delete',
                type: 'delete'
            }
        ]
    }

    return (   
        <Panel title="Access Rights">
            <DataResource
                addButtonText="Create Access Right" 
                addButtonLink="/admin/access/rights/create"
                data={data}
                {...props} 
            />
        </Panel>
    )
}

export default AccessRights; 